export default __webpack_public_path__ + "static/media/close-red.625ba8f0.svg";